export function buildChecklistItems(review, details, options = {}) {
    if (!review) {
        return [];
    }

    const user = review.cashout?.user || {};
    const audits = details?.user_audits || [];
    const hasOpenAudit = audits.some((audit) => audit.status !== "closed");
    const reviewStats = review.reviews || {};
    const sellerScore = review?.seller?.score ?? null;
    const commissionTypes = review.cashout?.commission_types || {};
    const commissionCount = Object.keys(commissionTypes).length;

    const items = [
        {
            id: "identity",
            label: "Confirmar identidade e contato",
            description: user.email ? `${user.email}` : "Sem email cadastrado",
            severity: hasOpenAudit ? "warning" : null,
            checked: false,
        },
        {
            id: "reputation",
            label: "Revisar reputação e score",
            description: `${reviewStats.approved || 0} aprovados • ${
                reviewStats.rejected || 0
            } reprovados • ${reviewStats.warning || 0} atenção`,
            severity:
                (reviewStats.rejected || 0) > 0 ||
                (sellerScore !== null && sellerScore <= 25)
                    ? "danger"
                    : (reviewStats.warning || 0) > 0 ||
                      (sellerScore !== null && sellerScore <= 50)
                    ? "warning"
                    : null,
            checked: false,
        },
        {
            id: "payments",
            label: "Validar métodos de pagamento e comissões",
            description:
                commissionCount > 0
                    ? `${commissionCount} tipos de comissão`
                    : "Sem comissões registradas",
            severity: commissionCount > 3 ? "warning" : null,
            checked: false,
        },
    ];

    if (options.includeSla) {
        items.push({
            id: "sla",
            label: "Garantir cumprimento do SLA crítico",
            description: "Saques até 12h precisam ser priorizados",
            severity: "warning",
            checked: false,
        });
    }

    return items;
}
